import axios from "axios";

const ADMIN_API_URL = "https://api.gosehari.com/admin";
const API_URL = "https://api.gosehari.com"


export const login = (loginData) => {
  return axios.post(`${ADMIN_API_URL}/login`, loginData, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getBookingList = (token) => {
  return axios.get(API_URL + "/booking/", {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const fetchAllTourPlaces = (token, id) => {
  return axios.get(`${API_URL}/display-title/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourPlace = (data) => {
  return axios.post(`${API_URL}/display-title`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateTourPlace = (token, id, data) => {
  return axios.put(`${API_URL}/display-title/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteTourPlace = (token, id) => {
  return axios.delete(`${API_URL}/display-title/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getTopThingsToDoList = (token) => {
  return axios.get(API_URL + "/topthings/", {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const createTopThingsToDoList = (token, formData) => {
  return axios.post(`${API_URL}/topthings/create`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const handleTopThingsToDoList = (token, id, formData) => {
  return axios.put(`${API_URL}/topthings/update/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const handleDeleteTopThingsToDoById = (token, id) => {
  return axios.delete(`${API_URL}/topthings/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchUnmappedTopThings = (token) => {
  return axios.get(`${API_URL}/title-unmapped`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchMappedTopThings = (token) => {
  return axios.get(`${API_URL}/data-mapped`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourOverview = (token, payload) => {
  return axios.post(`${API_URL}/overview`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourHighlights = (token, payload) => {
  return axios.post(`${API_URL}/highlights`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const createTourPackages = (token, payload) => {
  return axios.post(`${API_URL}/packages`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchCategoryDetails = (token, category) => {
  return axios.get(`${API_URL}/category?category=${category}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourTips = (token, thingId) => {
  return axios.get(`${API_URL}/tips/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourTips = (token, payload) => {
  return axios.post(`${API_URL}/tips`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourThingsToBring = (token, thingId) => {
  return axios.get(`${API_URL}/bring/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourThingsToBring = (token, payload) => {
  return axios.post(`${API_URL}/bring`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchTourDurationTimings = (token, thingId) => {
  return axios.get(`${API_URL}/duration/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourDurationTimings = (token, payload) => {
  return axios.post(`${API_URL}/duration`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourPickupLocations = (token, thingId) => {
  return axios.get(`${API_URL}/pickup/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourPickupLocations = (token, payload) => {
  return axios.post(`${API_URL}/pickup`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourInstructions = (token, thingId) => {
  return axios.get(`${API_URL}/instructions/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTourInstructions = (token, payload) => {
  return axios.post(`${API_URL}/instructions`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourDetails = (token, thingId) => {
  return axios.get(`${API_URL}/trip-details/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const createTourGallery = (token, formData) => {
  return axios.post(`${API_URL}/gallery`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    },
  });
};

export const fetchTourGallerySets = (token) => axios.get(`${API_URL}/tour-galleries`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchAvailableTourGalleryThings = (token) => axios.get(`${API_URL}/tour-galleries/available-things`, { headers: { Authorization: `Bearer ${token}` } });
export const createTourGallerySet = (token, formData) => axios.post(`${API_URL}/tour-galleries`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const updateTourGallerySet = (token, thingId, formData) => axios.put(`${API_URL}/tour-galleries/${thingId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const deleteTourGallerySet = (token, thingId) => axios.delete(`${API_URL}/tour-galleries/${thingId}`, { headers: { Authorization: `Bearer ${token}` } });

export const fetchRouteMaps = (token) => axios.get(`${API_URL}/route-maps`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchAvailableRouteMapThings = (token) => axios.get(`${API_URL}/route-maps/available-things`, { headers: { Authorization: `Bearer ${token}` } });
export const createRouteMap = (token, formData) => axios.post(`${API_URL}/route-maps`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const updateRouteMap = (token, thingId, formData) => axios.put(`${API_URL}/route-maps/${thingId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const deleteRouteMap = (token, thingId) => axios.delete(`${API_URL}/route-maps/${thingId}`, { headers: { Authorization: `Bearer ${token}` } });

export const fetchExplorePlaces = (token) => axios.get(`${API_URL}/explore-places`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchAvailableExploreThings = (token, excludeId) => axios.get(`${API_URL}/explore-places/available-things${excludeId ? `?excludeId=${encodeURIComponent(excludeId)}` : ""}`, { headers: { Authorization: `Bearer ${token}` } });
export const createExplorePlace = (token, formData) => axios.post(`${API_URL}/explore-places`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const updateExplorePlace = (token, id, formData) => axios.put(`${API_URL}/explore-places/${id}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const deleteExplorePlace = (token, id) => axios.delete(`${API_URL}/explore-places/${id}`, { headers: { Authorization: `Bearer ${token}` } });

// Complete Your Day recommendations shown on the Trip Details page.
export const fetchCompleteYourDaySets = (token) => axios.get(`${API_URL}/day-plan-sets`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchAvailableCompleteYourDayThings = (token) => axios.get(`${API_URL}/day-plan-sets/available-things`, { headers: { Authorization: `Bearer ${token}` } });
export const createCompleteYourDaySet = (token, formData) => axios.post(`${API_URL}/day-plan-sets`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const updateCompleteYourDaySet = (token, thingId, formData) => axios.put(`${API_URL}/day-plan-sets/${thingId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const deleteCompleteYourDaySet = (token, thingId) => axios.delete(`${API_URL}/day-plan-sets/${thingId}`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchRecommendationSets = (token, section) => axios.get(`${API_URL}/${section}/sets`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchAvailableRecommendationThings = (token, section) => axios.get(`${API_URL}/${section}/available-things`, { headers: { Authorization: `Bearer ${token}` } });
export const createRecommendationSet = (token, section, formData) => axios.post(`${API_URL}/${section}/sets`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const updateRecommendationSet = (token, section, thingId, formData) => axios.put(`${API_URL}/${section}/sets/${thingId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const deleteRecommendationSet = (token, section, thingId) => axios.delete(`${API_URL}/${section}/sets/${thingId}`, { headers: { Authorization: `Bearer ${token}` } });
export const fetchCompleteYourDayPlans = (token) => axios.get(`${API_URL}/day-plans`, { headers: { Authorization: `Bearer ${token}` } });
export const createCompleteYourDayPlan = (token, formData) => axios.post(`${API_URL}/day-plans`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const updateCompleteYourDayPlan = (token, id, formData) => axios.put(`${API_URL}/day-plans/${id}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
export const deleteCompleteYourDayPlan = (token, id) => axios.delete(`${API_URL}/day-plans/${id}`, { headers: { Authorization: `Bearer ${token}` } });
